import React, { PureComponent } from 'react';
import {
  Card, CardBody, Col, Button, ButtonToolbar, Popover
} from 'reactstrap';  
import { reduxForm } from 'redux-form';
import { SketchPicker } from 'react-color';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { hasAccess } from "../../Services/SecurityService";
import { addGeologia, updateGeologia } from "../../Services/GeologiaService";
import { FullWideNotification } from '../../../shared/components/Notification';
import NotificationSystem from 'rc-notification';

let notificationTC = null;

class CrudEdit extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      active: false,
      displayColorPicker: false,

      estados: [],
      checkboxEstados: [],
      checkboxEstadosSelected: [],

      geologiaCidade: [],
      checkboxCidades: [],
      checkboxCidadesSelected: [],

      grupos: [],
      checkboxGrupos: [],
      checkboxGruposSelected: [],
      
      substancias: [],
      checkboxSubstancias: [],
      checkboxSubstanciasSelected: [],

      data: {
        id: '',
				name: '',
				agrLITD: '',
				classe1: '',
				classe2: '',
				clIdLITO: '',
				codUnMET: '',
				codUnPLO: '',
				eonIdMAX: '',
				eonIdMIN: '',
				epcIdMAX: '',
				epcIdMIN: '',
				eraIdMAX: '',
				eraIdMIN: '',
				errIdMAX: '',
				errIdMIN: '',
				hierarquia: '',
				idadeMAX: '',
				idadeMIN: '',
				legMAPA1: '',
				legMAPA2: '',
				lito1: '',
				lito2: '',
				metodoMAX: '',
				metodoMIN: '',
				nomeUNID: '',
				provincia: '',
				qdeInMAX: '',
				qdeInMIN: '',
				simb1000: '',
				simbNEOP: '',
				sisGcMAX: '',
				sisGcMIN: '',
				sisIdMAX: '',
				sisIdMIN: '',
				subClasse1: '',
				subClasse2: '',
				description: '',
				photo: '',
				bibliografia: '',
				color: '#87CEFA',
        colorRGB: {r: 135, g: 206, b: 250, a: 1},
				status: "ATIVO",
				deleted: false,
				createdAt: '',
				updatedAt: ''
      }
    };
  }

  handleSubmit(e){
    const data = { ...this.state.data }


    console.log(data);

    if(this.validateEntries()){

      let rgb = JSON.stringify(data['colorRGB']);
      data['colorRGB'] = rgb;

      if(data.status === undefined || data.status === null || data.status === ''){
        data['status'] = 'ATIVO';
      }

      let request = {
        geologia: data,
        geologiaEstadoList: this.getGeologiaEstado(),
        geologiaCidadeList: this.getGeologiaCidade(),
        geologiaGrupoList: this.getGeologiaGrupo(),
        geologiaSubstanciaList: this.getGeologiaSubstancia()
      };
  
      if(data.id === undefined || data.id === null || data.id === ''){
        addGeologia(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable({}, this.props.t('forms.dataCreateSuccess'));
              this.clear();              
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }
            }
          } else {
            this.show('danger', this.props.t('forms.dataCreateError'));
          }
        });

      }else{
        updateGeologia(request)
        .then(obj => {
          if(obj !== null && obj !== undefined && obj.error === undefined){
            if(obj.erros.length === 0){
              this.props.updateTable(obj, this.props.t('forms.dataUpdateSuccess'));
            }else{
              if(obj.erros !== undefined && obj.erros !== undefined && obj.erros.length > 0){
                for(let i = 0; i < obj.erros.length; i++){
                  this.show('danger', this.props.t('erros.'+obj.erros[i]));
                }
              }  
            }
          } else {
            this.show('danger', this.props.t('forms.dataUpdateError'));
          }
        });
      }
    }
  }

  validateEntries(){
    const data = { ...this.state.data }
    let validated = true;

    if(data.simb1000 === undefined || data.simb1000 === null || data.simb1000 === ''){
      this.show('danger', this.props.t('forms.requiredFieldSimb1000'));
      validated = false;
    }

    if(data.color === undefined || data.color === null || data.color === ''){
      this.show('danger', this.props.t('forms.requiredFieldColor'));
      validated = false;
    }

    if(data.description === undefined || data.description === null || data.description === ''){
      this.show('danger', this.props.t('forms.requiredFieldDescription'));
      validated = false;
    }

    if(data.bibliografia === undefined || data.bibliografia === null || data.bibliografia === ''){
      this.show('danger', this.props.t('forms.requiredFieldBibliografia'));
      validated = false;
    }

    return validated;  
  }

  getGeologiaEstado() {
    let geologiaEstado = [];
    if(this.state.checkboxEstadosSelected.length > 0){
      for(let j = 0; j < this.state.checkboxEstadosSelected.length; j++){
        for(let i = 0; i < this.state.estados.length; i++){
          if(this.state.checkboxEstadosSelected[j].value === this.state.estados[i].id){
            geologiaEstado.push( {estado: this.state.estados[i]} );
            break;
          }
        }
      }
    }
    return geologiaEstado;
  }

  getGeologiaCidade() {
    let geologiaCidade = [];
    let cidades = [];
    let cidadeEncontrada = false;
    if(this.state.checkboxCidadesSelected.length > 0){
      for(let j = 0; j < this.state.checkboxCidadesSelected.length; j++){
        cidadeEncontrada = false;
        for(let e = 0; e < this.state.estados.length; e++){
          cidades = this.state.estados[e].cidades;
          for(let i = 0; i < cidades.length; i++){
            if(this.state.checkboxCidadesSelected[j].value === cidades[i].id){
              geologiaCidade.push( {cidade: cidades[i]} );
              cidadeEncontrada = true;
              break;
            }
          }
          if(cidadeEncontrada){
            break;
          }
        }
      }
    }
    return geologiaCidade;
  }

  getGeologiaGrupo() {
    let geologiaGrupo = [];
    if(this.state.checkboxGruposSelected.length > 0){
      for(let j = 0; j < this.state.checkboxGruposSelected.length; j++){
        for(let i = 0; i < this.state.grupos.length; i++){
          if(this.state.checkboxGruposSelected[j].value === this.state.grupos[i].id){
            geologiaGrupo.push( {grupo: this.state.grupos[i]} );
            break;
          }
        }
      }
    }
    return geologiaGrupo;
  }

  getGeologiaSubstancia() {
    let geologiaSubstancia = [];
    if(this.state.checkboxSubstanciasSelected.length > 0){
      for(let j = 0; j < this.state.checkboxSubstanciasSelected.length; j++){
        for(let i = 0; i < this.state.substancias.length; i++){
          if(this.state.checkboxSubstanciasSelected[j].value === this.state.substancias[i].id){
            geologiaSubstancia.push( {substancia: this.state.substancias[i]} );
            break;
          }
        }
      }
    }
    return geologiaSubstancia;
  }

  loadData(selected, estados, geologiaEstado, geologiaCidade, grupos, geologiaGrupo, substancias, geologiaSubstancia) {
    let options = [];
    let optionsC = [];
    let optionsSelected = [];
    let optionsSelectedC = [];
    let cidades = [];
    let geologiaCidadeList = [];
    let obj = {};
    let objC = {};
    if(geologiaCidade !== undefined && geologiaCidade !== null && geologiaCidade.length > 0 ){
      geologiaCidadeList = geologiaCidade;
    }
    if(estados !== undefined && estados !== null && estados.length > 0 && this.state.estados.length === 0){
      if(geologiaEstado !== undefined && geologiaEstado !== null && geologiaEstado.length > 0){
        for(let i = 0; i < estados.length; i++){
          obj = {value:estados[i].id, label: estados[i].name, uf: estados[i].uf, checked: false, checkedAll: false};
          for(let j = 0; j < geologiaEstado.length; j++){
            if(estados[i].id === geologiaEstado[j].estado.id){
              obj.checked = true;
              optionsSelected.push(obj);
              cidades = estados[i].cidades;

              for(let i2 = 0; i2 < cidades.length; i2++){
                objC = {value:cidades[i2].id, label: estados[i].uf + " - " + cidades[i2].name, uf: estados[i].uf, checked: false};
                for(let j2 = 0; j2 < geologiaCidadeList.length; j2++){
                  if(cidades[i2].id === geologiaCidadeList[j2].cidade.id){
                    objC.checked = true;
                    optionsSelectedC.push(objC);
                    break;
                  }
                }
                optionsC.push(objC);
              }
              break;
            }
          }
          options.push(obj);
        }
      }else{
        for(let i = 0; i < estados.length; i++){
          options.push({value:estados[i].id, label: estados[i].name, uf: estados[i].uf, checked: false, checkedAll: false});
        }
      }
      
      this.setState({ 
        checkboxEstados: options,
        checkboxEstadosSelected: optionsSelected,
        estados: estados,
        checkboxCidades: optionsC, 
        checkboxCidadesSelected: optionsSelectedC,
        geologiaCidade: geologiaCidade,
      })
    }

    if(grupos !== undefined && grupos !== null && grupos.length > 0 && this.state.grupos.length === 0){
      options = [];
      optionsSelected = [];
      if(geologiaGrupo !== undefined && geologiaGrupo !== null && geologiaGrupo.length > 0){
        for(let i = 0; i < grupos.length; i++){
          obj = {value:grupos[i].id, label: grupos[i].name, checked: true};
          for(let j = 0; j < geologiaGrupo.length; j++){
            if(grupos[i].id === geologiaGrupo[j].grupo.id){
              obj.checked = true;
              optionsSelected.push(obj);
              break;
            }
          }
          options.push(obj);
        }
      }else{
        for(let i = 0; i < grupos.length; i++){
          options.push({value:grupos[i].id, label: grupos[i].name, checked: false});
        }
      }

      this.setState({ 
        checkboxGrupos: options, 
        checkboxGruposSelected: optionsSelected,
        grupos: grupos 
      });
    }

    if(substancias !== undefined && substancias !== null && substancias.length > 0 && this.state.substancias.length === 0){
      options = [];
      optionsSelected = [];
      if(geologiaSubstancia !== undefined && geologiaSubstancia !== null && geologiaSubstancia.length > 0){
        for(let i = 0; i < substancias.length; i++){
          obj = {value:substancias[i].id, label: substancias[i].name, checked: true};
          for(let j = 0; j < geologiaSubstancia.length; j++){
            if(substancias[i].id === geologiaSubstancia[j].substancia.id){
              obj.checked = true;
              optionsSelected.push(obj);
              break;
            }
          }
          options.push(obj);
        }
      }else{
        for(let i = 0; i < substancias.length; i++){
          options.push({value:substancias[i].id, label: substancias[i].name, checked: false});
        }
      }

      this.setState({ 
        checkboxSubstancias: options, 
        checkboxSubstanciasSelected: optionsSelected,
        substancias: substancias 
      });
    }

    if(selected !== undefined && selected !== null){
      if(selected.id === 0){
        this.clear();
      }else {

        console.log(selected);

				// selected.agrLITD = (selected.agrLITD ? selected.agrLITD : '');
				// selected.classe1 =  (selected.classe1 ? selected.classe1 : '');
				// selected.classe2 =  (selected.classe2 ? selected.classe2 : '');
				// selected.clIdLITO =  (selected.clIdLITO ? selected.clIdLITO : '');
				// selected.codUnMET =  (selected.codUnMET ? selected.codUnMET : '');
				// selected.codUnPLO =  (selected.codUnPLO ? selected.codUnPLO : '');
				// selected.eonIdMAX =  (selected.eonIdMAX ? selected.eonIdMAX : '');
				// selected.eonIdMIN =  (selected.eonIdMIN ? selected.eonIdMIN : '');
				// selected.epcIdMAX =  (selected.epcIdMAX ? selected.epcIdMAX : '');
				// selected.epcIdMIN =  (selected.epcIdMIN ? selected.epcIdMIN : '');
				// selected.eraIdMAX =  (selected.eraIdMAX ? selected.eraIdMAX : '');
				// selected.eraIdMIN =  (selected.eraIdMIN ? selected.eraIdMIN : '');
				// selected.errIdMAX =  (selected.errIdMAX ? selected.errIdMAX : '');
				// selected.errIdMIN =  (selected.errIdMIN ? selected.errIdMIN : '');
				// selected.hierarquia =  (selected.hierarquia ? selected.hierarquia : '');
				// selected.idadeMAX =  (selected.idadeMAX ? selected.idadeMAX : '');
				// selected.idadeMIN =  (selected.idadeMIN ? selected.idadeMIN : '');
				// selected.legMAPA1 =  (selected.legMAPA1 ? selected.legMAPA1 : '');
				// selected.legMAPA2 =  (selected.legMAPA2 ? selected.legMAPA2 : '');
				// selected.lito1 =  (selected.lito1 ? selected.lito1 : '');
				// selected.lito2 =  (selected.lito2 ? selected.lito2 : '');
				// selected.metodoMAX =  (selected.metodoMAX ? selected.metodoMAX : '');
				// selected.metodoMIN =  (selected.metodoMIN ? selected.metodoMIN : '');
				// selected.nomeUNID =  (selected.nomeUNID ? selected.nomeUNID : '');
				// selected.provincia =  (selected.provincia ? selected.provincia : '');
				// selected.qdeInMAX =  (selected.qdeInMAX ? selected.qdeInMAX : '');
				// selected.qdeInMIN =  (selected.qdeInMIN ? selected.qdeInMIN : '');
				// selected.simb1000 =  (selected.simb1000 ? selected.simb1000 : '');
				// selected.simbNEOP =  (selected.simbNEOP ? selected.simbNEOP : '');
				// selected.sisGcMAX =  (selected.sisGcMAX ? selected.sisGcMAX : '');
				// selected.sisGcMIN =  (selected.sisGcMIN ? selected.sisGcMIN : '');
				// selected.sisIdMAX =  (selected.sisIdMAX ? selected.sisIdMAX : '');
        // selected.sisIdMIN =  (selected.sisIdMIN ? selected.sisIdMIN : '');
				// selected.subClasse1 =  (selected.subClasse1 ? selected.subClasse1 : '');
				// selected.subClasse2 =  (selected.subClasse2 ? selected.subClasse2 : '');
				// selected.description =  (selected.description ? selected.description : '');
				// selected.photo =  (selected.photo ? selected.photo : '');
				// selected.bibliografia =  (selected.bibliografia ? selected.bibliografia : '');
				// selected.color = (selected.color ? selected.color : '#87CEFA');
        // selected.colorRGB = (selected.colorRGB ? selected.colorRGB : {r: 135, g: 206, b: 250, a: 1});
				// selected.status =  (selected.status ? selected.status : 'ATIVO');
       
        // console.log(selected);

        this.setState({ 
          data: selected
        }, () => {});
      }
    }
  }

  componentDidMount() {
    const { selected, estados, geologiaEstado, geologiaCidade, grupos, geologiaGrupo, substancias, geologiaSubstancia } = this.props;

    this.loadData(selected, estados, geologiaEstado, geologiaCidade, grupos, geologiaGrupo, substancias, geologiaSubstancia);
    NotificationSystem.newInstance({ style: { top: 65 } }, n => notificationTC = n);
  }

  componentDidUpdate(props, state) {
    if(props.selected !== this.props.selected || props.estados !== this.props.estados || 
        props.geologiaEstado !== this.props.geologiaEstado || props.geologiaCidade !== this.props.geologiaCidade || 
        props.grupos !== this.props.grupos || props.geologiaGrupo !== this.props.geologiaGrupo || 
        props.substancias !== this.props.substancias || props.geologiaSubstancia !== this.props.geologiaSubstancia){
      this.loadData(this.props.selected, this.props.estados, this.props.geologiaEstado, this.props.geologiaCidade, this.props.grupos, this.props.geologiaGrupo, this.props.substancias, this.props.geologiaSubstancia);
    }
  }

  componentWillUnmount() {
    notificationTC.destroy();
  }

  updateField(event) {
    const data = { ...this.state.data }
    data[event.target.name] = event.target.value
    this.setState({ data });
  }

  updateCheckboxEstado(event) {
    let selecteds = [];
    let objC = {};
    let cidades = [];
    let optionsC = [];
    let optionsSelectedC = [];

    event.checked = !event.checked;
    if(this.state.checkboxEstadosSelected.length > 0){
      for(let i = 0; i < this.state.checkboxEstadosSelected.length; i++){
        if(this.state.checkboxEstadosSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxEstadosSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }

    for(let i = 0; i < selecteds.length; i++){
      for(let j = 0; j < this.state.estados.length; j++){
        if(selecteds[i].value === this.state.estados[j].id){
          cidades = this.state.estados[j].cidades;

          for(let i2 = 0; i2 < cidades.length; i2++){
            objC = {value:cidades[i2].id, label: this.state.estados[j].uf + " - " + cidades[i2].name, uf: this.state.estados[j].uf, checked: false};
            for(let j2 = 0; j2 < this.state.checkboxCidadesSelected.length; j2++){
              if(cidades[i2].id === this.state.checkboxCidadesSelected[j2].value){
                objC.checked = true;
                optionsSelectedC.push(objC);
                break;
              }
            }
            optionsC.push(objC);
          }
        }
      }
    }

    this.setState({ 
      checkboxEstadosSelected: selecteds.sort((a, b) => (a.label > b.label) ? 1 : -1),
      checkboxCidades: optionsC.sort((a, b) => (a.label > b.label) ? 1 : -1), 
      checkboxCidadesSelected: optionsSelectedC.sort((a, b) => (a.label > b.label) ? 1 : -1) 
    });
  }
  

  updateCheckboxCidadeAll(event){
    let selecteds = [];
    let item = {};
    event.checkedAll = !event.checkedAll;
    if(this.state.checkboxCidades.length > 0){
      for(let i = 0; i < this.state.checkboxCidades.length; i++){
        item = this.state.checkboxCidades[i];
        if(item.uf === event.uf){
          item.checked = event.checkedAll;
        }
        if(item.checked){
          selecteds.push(item);
        }
      }
    }
    this.setState({ 
      checkboxCidadesSelected: selecteds.sort((a, b) => (a.label > b.label) ? 1 : -1) 
    });
  }


  updateCheckboxCidade(event) {
    let selecteds = [];
    event.checked = !event.checked;
    if(this.state.checkboxCidadesSelected.length > 0){
      for(let i = 0; i < this.state.checkboxCidadesSelected.length; i++){
        if(this.state.checkboxCidadesSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxCidadesSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }
    this.setState({ 
      checkboxCidadesSelected: selecteds.sort((a, b) => (a.label > b.label) ? 1 : -1)  
    });
  }


  updateCheckboxGrupo(event) {
    let selecteds = [];
    event.checked = !event.checked;
    if(this.state.checkboxGruposSelected.length > 0){
      for(let i = 0; i < this.state.checkboxGruposSelected.length; i++){
        if(this.state.checkboxGruposSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxGruposSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }
    this.setState({ checkboxGruposSelected: selecteds });
  }


  updateCheckboxSubstancia(event) {
    let selecteds = [];
    event.checked = !event.checked;
    if(this.state.checkboxSubstanciasSelected.length > 0){
      for(let i = 0; i < this.state.checkboxSubstanciasSelected.length; i++){
        if(this.state.checkboxSubstanciasSelected[i].value !== event.value){
          selecteds.push(this.state.checkboxSubstanciasSelected[i]);
        }
      }
    }
    if(event.checked){
      selecteds.push(event);
    }
    this.setState({ checkboxSubstanciasSelected: selecteds });
  }


  clear(){
    const data = { ...this.state.data }
    data['id'] = '';
    data['agrLITD'] = '';
    data['classe1'] = '';
    data['classe2'] = '';
    data['clIdLITO'] = '';
    data['codUnMET'] = '';
    data['codUnPLO'] = '';
    data['eonIdMAX'] = '';
    data['eonIdMIN'] = '';
    data['epcIdMAX'] = '';
    data['epcIdMIN'] = '';
    data['eraIdMAX'] = '';
    data['eraIdMIN'] = '';
    data['errIdMAX'] = '';
    data['errIdMIN'] = '';
    data['hierarquia'] = '';
    data['idadeMAX'] = '';
    data['idadeMIN'] = '';
    data['legMAPA1'] = '';
    data['legMAPA2'] = '';
    data['lito1'] = '';
    data['lito2'] = '';
    data['metodoMAX'] = '';
    data['metodoMIN'] = '';
    data['nomeUNID'] = '';
    data['provincia'] = '';
    data['qdeInMAX'] = '';
    data['qdeInMIN'] = '';
    data['simb1000'] = '';
    data['simbNEOP'] = '';
    data['sisGcMAX'] = '';
    data['sisGcMIN'] = '';
    data['sisIdMAX'] = '';
    data['sisIdMIN'] = '';
    data['subClasse1'] = '';
    data['subClasse2'] = '';
    data['description'] = '';
    data['photo'] = false;
    data['bibliografia'] = '';
    data['color'] = '#87CEFA';
    data['colorRGB'] = {r: 135, g: 206, b: 250, a: 1};
    data['status'] = '';
    data['deleted'] = '';
    data['createdAt'] = '';
    data['updatedAt'] = '';
    data['name'] = '';

    this.setState({ 
      data,
      checkboxEstadosSelected: [],
      checkboxCidadesSelected: [],
      checkboxCidades: [],
      checkboxGruposSelected: [],
      checkboxSubstanciasSelected: [],
      active: false,
      displayColorPicker: false
    }, () => {});
  }

  cancel(event) {
    this.clear();
    this.props.updateTable({});
  }

  show = (color, message) => {
    return notificationTC.notice({
      content: <FullWideNotification
        color={color}
        message={message}
        />,
      duration: 3,
      closable: true,
      style: { top: 0, left: 0 },
      className: `full ltr-support`,
    });
  };

  handleClick = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ displayColorPicker: !prevState.displayColorPicker, active: !prevState.active }));
  };

  handleChange = (color) => {
    const data = { ...this.state.data }
    data['color'] = color.hex;
    data['colorRGB'] = color.rgb;
    this.setState({ data });
  };

  render() {
    const { t } = this.props;
    const { data, active, displayColorPicker } = this.state;
    const color = data.color;
    const rgb = data.colorRGB;
    
    let notOK = !hasAccess("MENU_GEOLOGY_SAVE");

    let isEdit = false;
    if(this.state.data.id !== '' && this.state.data.id > 0){
      isEdit = true;
    }

    let checkboxesEstadosAll = [];
    let checkboxesEstados = [];
    let checkboxesCidades = [];
    let checkboxesGrupos = [];
    let checkboxesSubstancias = [];
    let checked = false;

    let total = this.state.checkboxEstados.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checked = false;
        if(this.state.checkboxEstadosSelected.includes(this.state.checkboxEstados[i])){
          checked = true;
          checkboxesEstadosAll.push(
            <div key={"divestadosAll_"+this.state.checkboxEstados[i].value} className='form__form-inline' style={{width: '60px'}}>
              <input type="checkbox" 
                id={"checkboxestadosAll_"+this.state.checkboxEstados[i].value} 
                name={"checkboxestadosAll_"+this.state.checkboxEstados[i].value} 
                style={{float: 'left', width: '30px', height: '18px'}}
                onChange={e => this.updateCheckboxCidadeAll(this.state.checkboxEstados[i])}
                checked={this.state.checkboxEstados[i].checkedAll} 
              />
                <label 
                  key={"labelestadosAll_"+this.state.checkboxEstados[i].value}
                  htmlFor={"checkboxestadosAll_"+this.state.checkboxEstados[i].value} 
                  style={{margin: 0, height: '25px'}}>
                  {this.state.checkboxEstados[i].uf}
                </label>
            </div>
          );
        }
        checkboxesEstados.push(
          <div key={"divestados_"+this.state.checkboxEstados[i].value} className='form__form-inline' style={{width: '170px'}}>
            <input type="checkbox" 
              id={"checkboxestados_"+this.state.checkboxEstados[i].value} 
              name={"checkboxestados_"+this.state.checkboxEstados[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxEstado(this.state.checkboxEstados[i])}
              checked={checked} 
            />
              <label 
                key={"labelestados_"+this.state.checkboxEstados[i].value}
                htmlFor={"checkboxestados_"+this.state.checkboxEstados[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxEstados[i].label}
              </label>
          </div>
        );
      }
    }

    total = this.state.checkboxCidades.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checkboxesCidades.push(
          <div key={"divcidades_"+this.state.checkboxCidades[i].value} className='form__form-inline' style={{width: '205px'}}>
            <input type="checkbox" 
              id={"checkboxcidades_"+this.state.checkboxCidades[i].value} 
              name={"checkboxcidades_"+this.state.checkboxCidades[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxCidade(this.state.checkboxCidades[i])}
              checked={this.state.checkboxCidadesSelected.includes(this.state.checkboxCidades[i])} 
            />
              <label 
                key={"labelcidades_"+this.state.checkboxCidades[i].value}
                htmlFor={"checkboxcidades_"+this.state.checkboxCidades[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxCidades[i].label}
              </label>
          </div>
        );
      }
    }

    total = this.state.checkboxGrupos.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checkboxesGrupos.push(
          <div key={"divgrupos_"+this.state.checkboxGrupos[i].value} className='form__form-inline' style={{width: '205px'}}>
            <input type="checkbox" 
              id={"checkboxgrupos_"+this.state.checkboxGrupos[i].value} 
              name={"checkboxgrupos_"+this.state.checkboxGrupos[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxGrupo(this.state.checkboxGrupos[i])}
              checked={this.state.checkboxGruposSelected.includes(this.state.checkboxGrupos[i])} 
            />
              <label 
                key={"labelgrupos_"+this.state.checkboxGrupos[i].value}
                htmlFor={"checkboxgrupos_"+this.state.checkboxGrupos[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxGrupos[i].label}
              </label>
          </div>
        );
      }
    }

    total = this.state.checkboxSubstancias.length;
    if(total > 0){
      for(let i = 0; i < total; i++){
        checkboxesSubstancias.push(
          <div key={"divsubstancias_"+this.state.checkboxSubstancias[i].value} className='form__form-inline' style={{width: '205px'}}>
            <input type="checkbox" 
              id={"checkboxsubstancias_"+this.state.checkboxSubstancias[i].value} 
              name={"checkboxsubstancias_"+this.state.checkboxSubstancias[i].value} 
              style={{float: 'left', width: '30px', height: '18px'}}
              onChange={e => this.updateCheckboxSubstancia(this.state.checkboxSubstancias[i])}
              checked={this.state.checkboxSubstanciasSelected.includes(this.state.checkboxSubstancias[i])} 
            />
              <label 
                key={"labelsubstancias_"+this.state.checkboxSubstancias[i].value}
                htmlFor={"checkboxsubstancias_"+this.state.checkboxSubstancias[i].value} 
                style={{margin: 0, height: '25px'}}>
                {this.state.checkboxSubstancias[i].label}
              </label>
          </div>
        );
      }
    }

    console.log("epcIdMIN: ");
    console.log(this.state.data.epcIdMIN);

    return (
      <Col md={12} lg={12}>
        <Card>
          <CardBody>
            <div className="form__form-group">
              <h3 className="page-subhead subhead">{t('forms.createUpdate')}</h3>
            </div>
            <div className="form">

              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.simb1000')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="hidden" 
                      name="id"
                      value={this.state.data.id} />
                    <input type="text" 
                      name="simb1000"
                      value={this.state.data.simb1000}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>

                <div className="form__form-group" style={{display: 'flow-root', flexWrap: 'wrap'}}>
                  <div style={{width: '100%'}}>
                    <span className="form__form-group-label" style={{width: '48%', float: 'left'}}>
                      {t('forms.eonIdMIN')} 
                    </span>
                    <span className="form__form-group-label" style={{width: '48%', float: 'right'}}>
                      {t('forms.eraIdMIN')} 
                    </span>
                  </div>
                  <div className="form__form-inline" style={{width: '48%', marginRight: '4%'}}>
                    <input type="text" 
                      name="eonIdMIN"
                      value={this.state.data.eonIdMIN}
                      onChange={e => this.updateField(e)}
                    />
                  </div>
                  <div className="form__form-inline" style={{width: '48%'}}>
                    <input type="text" 
                      name="eraIdMIN"
                      value={this.state.data.eraIdMIN}
                      onChange={e => this.updateField(e)}
                    />
                  </div>
                </div>

                <div className="form__form-group" style={{display: 'flow-root', flexWrap: 'wrap'}}>
                  <div style={{width: '100%'}}>
                    <span className="form__form-group-label" style={{width: '48%', float: 'left'}}>
                      {t('forms.eonIdMAX')} 
                    </span>
                    <span className="form__form-group-label" style={{width: '48%', float: 'right'}}>
                      {t('forms.eraIdMAX')} 
                    </span>
                  </div>
                  <div className="form__form-inline" style={{width: '48%', marginRight: '4%'}}>
                    <input type="text" 
                      name="eonIdMAX"
                      value={this.state.data.eonIdMAX}
                      onChange={e => this.updateField(e)}
                    />
                  </div>
                  <div className="form__form-inline" style={{width: '48%'}}>
                    <input type="text" 
                      name="eraIdMAX"
                      value={this.state.data.eraIdMAX}
                      onChange={e => this.updateField(e)}
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.classe1')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="classe1"
                      value={this.state.data.classe1}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>
              </div>


              <div className="form__half">
                <div className="form__form-group">
                  <span title={t('forms.requiredField')} className="form__form-group-label">
                    {t('forms.nomeUNID')} <span style={{color: "#ff0000"}}>*</span>
                  </span>
                  <div className="form__form-group-field">
                    <input type="text" 
                      name="nomeUNID"
                      value={this.state.data.nomeUNID}
                      onChange={e => this.updateField(e)}
                      required
                    />
                  </div>
                </div>

                <div className="form__form-group" style={{display: 'flow-root', flexWrap: 'wrap'}}>
                  <div style={{width: '100%'}}>
                    <span className="form__form-group-label" style={{width: '48%', float: 'left'}}>
                      {t('forms.idadeMIN')} 
                    </span>
                    <span className="form__form-group-label" style={{width: '48%', float: 'right'}}>
                      {t('forms.epcIdMIN')} 
                    </span>
                  </div>
                  <div className="form__form-inline" style={{width: '48%', marginRight: '4%'}}>
                    <input type="text" 
                      name="idadeMIN"
                      value={this.state.data.idadeMIN}
                      onChange={e => this.updateField(e)}
                    />
                  </div>
                  <div className="form__form-inline" style={{width: '48%'}}>
                    <input type="text" 
                      name="epcIdMIN"
                      value={this.state.data.epcIdMIN}
                      onChange={e => this.updateField(e)}
                    />
                  </div>
                </div>

                <div className="form__form-group" style={{display: 'flow-root', flexWrap: 'wrap'}}>
                  <div style={{width: '100%'}}>
                    <span className="form__form-group-label" style={{width: '48%', float: 'left'}}>
                      {t('forms.idadeMAX')} 
                    </span>
                    <span className="form__form-group-label" style={{width: '48%', float: 'right'}}>
                      {t('forms.epcIdMAX')} 
                    </span>
                  </div>
                  <div className="form__form-inline" style={{width: '48%', marginRight: '4%'}}>
                    <input type="text" 
                      name="idadeMAX"
                      value={this.state.data.idadeMAX}
                      onChange={e => this.updateField(e)}
                    />
                  </div>
                  <div className="form__form-inline" style={{width: '48%'}}>
                    <input type="text" 
                      name="epcIdMAX"
                      value={this.state.data.epcIdMAX}
                      onChange={e => this.updateField(e)}
                    />
                  </div>
                </div>

                <div className="form__form-group">
                  <span className="form__form-group-label">
                    {t('forms.color')} 
                  </span>
                  <div className="form__form-group-field">
                    <div className="color-picker">
                      <button
                        type="button"
                        className={`color-picker__button${active ? ' active' : ''}`}
                        onClick={this.handleClick}
                        id="color"
                      >
                        <p className="color-picker__color">{color}</p>
                        <div className="color-picker__color-view" style={{ backgroundColor: color }} />
                      </button>
                      <Popover
                        isOpen={displayColorPicker}
                        target="color"
                        placement="bottom"
                        className="color-picker__popover"
                      >
                        <SketchPicker
                          color={rgb}
                          onChange={e => this.handleChange(e)}
                        />
                      </Popover>
                    </div>                    
                  </div>
                </div>
              </div>
              

              <div className="form__form-group">
                <span title={t('forms.requiredField')} className="form__form-group-label">
                  {t('forms.lito1')} <span style={{color: "#ff0000"}}>*</span>
                </span>
                <div className="form__form-group-field">
                  <input type="text" 
                    name="lito1"
                    value={this.state.data.lito1}
                    onChange={e => this.updateField(e)}
                    required
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.lito2')} 
                </span>
                <div className="form__form-group-field">
                  <input type="text" 
                    name="lito2"
                    value={this.state.data.lito2}
                    onChange={e => this.updateField(e)}
                    
                  />
                </div>
              </div>


              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.description')}
                </span>
                <div className="form__form-group-field">
                  <textarea 
                    name="description"
                    value={this.state.data.description || ""}
                    style={{width: "100%", height: "25px"}}
                    onChange={e => this.updateField(e)}
                  />
                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.bibliografia')} 
                </span>
                <div className="form__form-group-field">
                  <textarea 
                    name="bibliografia"
                    value={this.state.data.bibliografia || ""}
                    style={{width: "100%", height: "25px"}}
                    onChange={e => this.updateField(e)}
                  />
                </div>
              </div>


              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.grupo_form.title')} 
                </span>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px'}}>
                  
                  {checkboxesGrupos}

                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.substancia_form.title')} 
                </span>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px'}}>
                  
                  {checkboxesSubstancias}

                </div>
              </div>
              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.estado_form.title')} 
                </span>
                <div className="form__form-group-field" 
                  style={{border: '1px solid #CCCCCC', height: '160px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px'}}>
                  
                  {checkboxesEstados}

                </div>
              </div>
              <div className="form__form-group">
                <div style={{float: 'left', marginRight: '5px'}}>
                  <span className="form__form-group-label">
                    {t('forms.cidade_form.title')} 
                  </span>
                </div>
                <div style={{float: 'left'}}>
                {checkboxesEstadosAll}
                </div>
                <div className="form__form-group-field" 
                  style={{clear: 'both', border: '1px solid #CCCCCC', height: '400px', overflowY: 'auto', 
                          display: 'flow-root', flexWrap: 'wrap', paddingTop: '5px'}}>
                  
                  {checkboxesCidades}

                </div>
              </div>

              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.status')}
                </span>
                <div className="form__form-group-field">
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.ativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'ATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.ativo')}</span>
                  </label>
                  <label className="radio-btn">
                    <input className="radio-btn__radio"
                      name="status"
                      type="radio"
                      value={t('forms.inativo')}
                      onChange={e => this.updateField(e)}
                      checked={this.state.data.status === 'INATIVO' ? true : false}
                    />
                    <span className="radio-btn__radio-custom"></span>
                    <span className="radio-btn__label">{t('forms.inativo')}</span>
                  </label>
                </div>
              </div>
              
              <div className="form__form-group">
                <span className="form__form-group-label">
                  {t('forms.photo')} 
                </span>
                <div className="form__form-group-field">
                  
                </div>
              </div>
              <ButtonToolbar className="form__button-toolbar">
                <Button color="primary" type="submit" disabled={notOK}
                  onClick={e => this.handleSubmit(e)}>
                  {t('forms.save')}
                </Button>
                <Button type="button" onClick={e => this.cancel(e)}>
                  {isEdit ? t('forms.voltar') : t('forms.cancel')}
                </Button>
              </ButtonToolbar>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'geologiaEdit', 
})(withTranslation('common')(CrudEdit));
